import { createFileRoute } from "@tanstack/react-router";
import type { ClientUserHydrated } from "api-types/users/usersResponses";
import Footer from "lib/components/footers/LandingPageFooter";
import LoginForm from "lib/components/home/LoginForm";
import Navbar from "lib/components/home/Navbar";
import { useAppRouterParams } from "lib/routeHelpers";
import { useUserContext } from "lib/state/UserContextProvider";
import getPageTitle from "lib/utils/getPageTitle";
import { useEffect, useState } from "react";
import { Helmet as Head } from "react-helmet-async";
import styles from "../Home.module.scss";

function LoginPage() {
  const [mounted, setMounted] = useState(false);
  const [localUser, setLocalUser] = useState<ClientUserHydrated | null>(null);
  const { user } = useUserContext();
  const { redirectTo } = useAppRouterParams();
  const redirectPath = redirectTo ? decodeURIComponent(redirectTo) : undefined;

  useEffect(() => {
    setMounted(true);
    setLocalUser(user);
  }, [user]);

  if (!mounted) {
    return <div style={{ visibility: "hidden" }} />;
  }

  return (
    <div className={styles.wrapper}>
      <Head>
        <title>{getPageTitle("Login")}</title>
        <meta name="robots" content="noindex" />
      </Head>
      <Navbar />
      <div className="grid-container full-height">
        <LoginForm user={localUser} redirectTo={redirectPath} />
      </div>
      <Footer />
    </div>
  );
}

export const Route = createFileRoute("/account/login")({
  component: LoginPage,
});
